import type { FC } from 'react';

export const Divider = ({ className }: { className?: string }) => {
  return (
    <div
      className={`yep_ex-border-b yep_ex-border-neutral-200 ${className ?? ''}`}
    />
  );
};
